<template>
  <div>
    <div class="shim" :style="{ opacity }"></div>
    <div class="content">
      <div class="inner" @click.self="$emit('click')">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.shim,
.content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}
.shim {
  background-color: black;
}
.content {
  opacity: 1;

  & > .inner {
    width: 100vw;
    height: 100vh;
    vertical-align: middle;
    text-align: center;
  }
}
</style>
<script>
export default {
  props: {
    opacity: {
      type: Number,
      required: false,
      default: 0.6,
    },
  },
  emits: ["click"],
};
</script>
